export default "__VITE_ASSET__kGDxmsN6__"